import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "mydata",
  initialState: {
    userlogin: false,
    authUser: ""
  },
  reducers: {
    setuserloginStored: (state, action) => {
      let tmp = action.payload;
      state.userlogin = tmp;
    },
    setauthUserStored: (state, action) => {
      let tmp = action.payload;
      state.authUser = tmp;
    },
  },
});

export const { setuserloginStored , setauthUserStored } = counterSlice.actions;

export const getUserlogin = (state) => state.counter.userlogin;
export const getAuthuser = (state) => state.counter.authUser;

export default counterSlice.reducer;
